const sliderCursorButton = document.querySelectorAll('[data-slider-cursor-button]');
const checkCursor = window.matchMedia("(any-pointer: fine)").matches;
document.addEventListener('DOMContentLoaded', () => {
	if (checkCursor) {
		sliderCursorButton.forEach(btn => {
			btn.parentElement.addEventListener('mousemove', (e) => {
				btn.style.position = 'fixed';
				btn.style.left = e.clientX + -36 + 'px';
				btn.style.top = e.clientY + -36 + 'px';
			})
		})
	} else {
		sliderCursorButton.forEach(btn => btn.parentElement.hidden = true)
	}
});
